import { Link } from "react-router-dom";

export function AuthFrame({
  title,
  eyebrow,
  children,
  alternate,
}: {
  title: string;
  eyebrow: string;
  children: React.ReactNode;
  alternate: { to: string; label: string; prompt: string };
}) {
  return (
    <main className="auth-shell">
      <section className="auth-intro" aria-labelledby="auth-title">
        <p className="eyebrow">STELLAR COLONY // {eyebrow}</p>
        <h1 id="auth-title">{title}</h1>
        <p>在真实航行约束下规划一个跨越世纪的文明。服务器持续结算，所有决策保存在你的在线存档中。</p>
        <dl className="auth-signal" aria-label="系统状态">
          <div><dt>模拟</dt><dd>服务端权威</dd></div>
          <div><dt>周期</dt><dd>1 游戏年 ≈ 30 分钟现实时间</dd></div>
          <div><dt>视图</dt><dd>文字 + SVG</dd></div>
        </dl>
      </section>
      <section className="auth-panel">
        {children}
        <p className="auth-alternate">{alternate.prompt} <Link to={alternate.to}>{alternate.label}</Link></p>
      </section>
    </main>
  );
}
